// extracted by mini-css-extract-plugin
module.exports = {"main":"hero_main__2w7y0","sub":"hero_sub__PLu7B"};